export * from './absence.service';
import { AbsenceService } from './absence.service';
export * from './absence.serviceInterface';
export * from './action.service';
import { ActionService } from './action.service';
export * from './action.serviceInterface';
export * from './attendence.service';
import { AttendenceService } from './attendence.service';
export * from './attendence.serviceInterface';
export * from './attendenceSetting.service';
import { AttendenceSettingService } from './attendenceSetting.service';
export * from './attendenceSetting.serviceInterface';
export * from './authorization.service';
import { AuthorizationService } from './authorization.service';
export * from './authorization.serviceInterface';
export * from './card.service';
import { CardService } from './card.service';
export * from './card.serviceInterface';
export * from './center.service';
import { CenterService } from './center.service';
export * from './center.serviceInterface';
export * from './dashboard.service';
import { DashboardService } from './dashboard.service';
export * from './dashboard.serviceInterface';
export * from './device.service';
import { DeviceService } from './device.service';
export * from './device.serviceInterface';
export * from './role.service';
import { RoleService } from './role.service';
export * from './role.serviceInterface';
export * from './terminal.service';
import { TerminalService } from './terminal.service';
export * from './terminal.serviceInterface';
export * from './user.service';
import { UserService } from './user.service';
export * from './user.serviceInterface';
export * from './usersGroup.service';
import { UsersGroupService } from './usersGroup.service';
export * from './usersGroup.serviceInterface';
export const APIS = [AbsenceService, ActionService, AttendenceService, AttendenceSettingService, AuthorizationService, CardService, CenterService, DashboardService, DeviceService, RoleService, TerminalService, UserService, UsersGroupService];
